import { render } from "./ButtonView.vue?vue&type=template&id=5387edb4"
const script = {}

import "./ButtonView.vue?vue&type=style&index=0&id=5387edb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__